import script from "./DotSeparator.vue?vue&type=script&setup=true&lang=js"
export * from "./DotSeparator.vue?vue&type=script&setup=true&lang=js"

import "./DotSeparator.vue?vue&type=style&index=0&id=19f44d50&scoped=true&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f44d50"]])

export default __exports__